import { CampaignObjective } from '../../model/campaign'

export const mapObjectiveFromRawData = (rawData: any): CampaignObjective => ({
  entryId: rawData.Id,
  title: rawData.Title,
  campaignId: rawData.CampaignId,
  content: rawData.Content,
  countries: JSON.parse(rawData.Countries || '[]'),
  isVisible: rawData.IsVisible,
})
